import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {isDeepEqual} from 'src/utils/isDeepEqual';

import {FlatButton} from '@pb/kit-component-button';


import {useDefaultFilters} from '../../hooks/useDefaultFilters';
import {notificationsListStateActions, notificationsListStateSelector} from '../../slices/notification-search-criteria.slice';

export const DefaultFilters = () => {
    const dispatch = useDispatch();
    const state = useSelector(notificationsListStateSelector);
    const defaultFilters = useDefaultFilters();

    const defaultFiltersHandler = useCallback(() => {
        dispatch(notificationsListStateActions.setFilters(defaultFilters));
    }, [defaultFilters, dispatch]);

    return (
        <FlatButton
            disabled={isDeepEqual({prev: defaultFilters, current: state.filters})}
            onClick={defaultFiltersHandler}>
            <strong>
                Default Filters
            </strong>
        </FlatButton>
    );
};
